module.exports = __webpack_public_path__ + "img/first_course_session--active.0d906369.svg";